import React from 'react';
import { Navigate } from 'react-router';
import Base from './Base';
import Constant from "./Constant";
import SelectAsync from 'react-select/async';
//https://s-yadav.github.io/react-number-format/docs/numeric_format/
import NumberFormat from 'react-number-format';
import DatePicker from 'react-datepicker2';

export default class Stuff extends Base {
    constructor(props) {
        super(props);
        this.state = {
            id: this.isNull(props.Id) ? this.defaultGuid() : props.Id,
            inline: this.isNull(props.Inline) ? false : props.Inline,
            fromAutoComplete: this.isNull(props.FromAutoComplete) ? false : props.FromAutoComplete,
            onSetStuff: this.isNull(props.OnSetStuff) ? null : props.OnSetStuff,
            callbackData: this.isNull(props.CallbackData) ? null : props.CallbackData,
            caller: props.Caller,
            data: null,
            loading: true,
            userGroups: [],
            branches: [],
            pic: '',
        };
        this.keyDownFunction = this.keyDownFunction.bind(this);
    }
    componentWillUnmount() {
        this.removeKeyDown();
    }
    componentDidMount() {
        this.addKeyDown();
        this.httpPost("api/v1/stuff/get", {
            id: this.getCurrentFormId(),
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.setState({
                        userGroups: data.userGroups,
                        branches: data.branches, 
                        data: data,
                        loading: false
                    })
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    setProfilePic(_file) {
        this.getBase64(_file).then(file => {
            this.state.pic = file;
        });
    }
    save(e) {
        e.preventDefault();

        if (this.isBlank(this.state.data.record.code)) this.state.data.record.code = 0;
        if (this.isBlank(this.state.data.record.modulusUnitRate)) this.state.data.record.modulusUnitRate = 0;
        if (this.isBlank(this.state.data.record.defaultAmount)) this.state.data.record.defaultAmount = 0;
        if (this.isBlank(this.state.data.record.price)) this.state.data.record.price = 0;
        if (this.isBlank(this.state.data.record.reorderCount)) this.state.data.record.reorderCount = 0;
        if (this.isBlank(this.state.data.record.reorderPoint)) this.state.data.record.reorderPoint = 0;

        this.httpPost("api/v1/stuff/save", {
            id: this.getCurrentFormId(),
            companyId: this.state.data.global.company.id,
            reorderCount: this.state.data.record.reorderCount,
            reorderPoint: this.state.data.record.reorderPoint,
            name: this.state.data.record.name,
            name2: this.state.data.record.name2,
            type: this.state.data.record.type,
            unitId: this.state.data.record.unitId,
            groupId: this.state.data.record.groupId,
            warehouseId: this.state.data.record.warehouseId,
            taxNumber: this.state.data.record.taxNumber,
            price: parseInt(this.state.data.record.price),
            taxRate: parseInt(this.state.data.record.taxRate),
            code: parseInt(this.state.data.record.code),
            visibleUnit: this.state.data.record.visibleUnit,
            modulusUnitId: this.state.data.record.modulusUnitId,
            barcode: this.state.data.record.barcode,
            description: this.state.data.record.description,            
            defaultAmount: parseFloat(this.state.data.record.defaultAmount),     
            modulusUnitRate: parseFloat(this.state.data.record.modulusUnitRate),
            formulas: this.state.data.formulas,
            userGroups: this.state.userGroups,
            branches: this.state.branches,
            pic: this.state.pic,
            expireDate: this.convertMomentToDb(this.state.data.record.expireDate),
            productDate: this.convertMomentToDb(this.state.data.record.productDate),
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.showSuccessMessage("اطلاعات با موفقیت ذخیره شد");

                    if (this.state.fromAutoComplete) {
                        if (this.isNull(this.state.onSetStuff)) {
                            this.state.caller.setStuff({
                                fullCode: data.record.code,
                                accountId: data.record.accountId,
                                value: data.record.id,
                                label: data.record.code + "-" + this.state.data.record.name
                            });
                        }
                        else {
                            this.state.onSetStuff({
                                fullCode: data.record.code,
                                accountId: data.record.accountId,
                                value: data.record.id,
                                label: data.record.code + "-" + this.state.data.record.name
                            }, this.state.caller, this.state.callbackData);
                        }
                    }
                    else
                        this.state.caller.refreshData();
                    this.closeMe();
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    setGroup(e) {
        if (e.value == -1) {
            this.state.data.record.groupId = this.defaultGuid();
            this.state.data.record.groupName = '';
            this.showComponents({ component: <Constant Type={2} Caller={this} FromAutoComplete={true} /> });
            return;
        }
        this.state.data.record.groupId = e.value;
        this.state.data.record.groupName = e.label;
        this.setState({ data: this.state.data });
    }
    setWarehouse(e) {
        this.state.data.record.warehouseId = e.value;
        this.state.data.record.warehouseName = e.label;
        this.setState({ data: this.state.data });
    }
    setUnit(e) {
        this.state.data.record.unitId = e.value;
        this.state.data.record.unitName = e.label;
        this.setState({ data: this.state.data });
    }
    setModulusUnit(e) {
        if (!this.isNull(e)) {
            this.state.data.record.modulusUnitId = e.value;
            this.state.data.record.modulusUnitName = e.label;
        }
        else {
            this.state.data.record.modulusUnitId = this.getDefaultGuid();
            this.state.data.record.modulusUnitName = '';
        }
        this.setState({ data: this.state.data });
    }    
    setType(e) {
        this.state.data.record.type = parseInt(e.target.value);
        this.setState({ data: this.state.data });
    }
    addFormula() {
        this.state.data.formulas.push({
            id: this.uuidv4(),
            itemId: this.getDefaultGuid(),
            itemName: '',
            count: 0,
            secondaryStuffId: this.getDefaultGuid(),
            secondaryStuffN: '',
            trashWastCount: 0,
            wastCount: 0,
            unitId: this.getDefaultGuid(),
            unitName: '',
            modulusUnitId: this.getDefaultGuid(),
            modulusUnitName: '',
            modulusCount: 0,
            modulusUnitRate: 0,
        });
        this.setState({ data: this.state.data });
    }
    setFormulaValue(id,f, e) {
        for (var i = 0; i < this.state.data.formulas.length; i++) {
            if (this.state.data.formulas[i].id === id) {
                if (f === 'itemId') {
                    this.state.data.formulas[i][f] = e.value;
                    this.state.data.formulas[i].itemName = e.label;
                    this.state.data.formulas[i]['unitName'] = e.unitName;
                    this.state.data.formulas[i]['unitId'] = e.unitId;
                    this.state.data.formulas[i]['modulusUnitId'] = e.modulusUnitId;
                    this.state.data.formulas[i]['modulusUnitName'] = e.modulusUnitName;
                    this.state.data.formulas[i]['modulusUnitRate'] = e.modulusUnitRate;
                    this.state.data.formulas[i]['modulusCount'] = 0;
                    this.state.data.formulas[i]['count'] = 0;
                }
                if (f === 'secondaryStuffId') {
                    this.state.data.formulas[i][f] = e.value;
                    this.state.data.formulas[i].secondaryStuffName = e.label;
                }
                if (f === 'count') {
                    this.state.data.formulas[i][f] = e;
                    this.updateModulusCount(i);
                }
                if (f === 'modulusCount') {
                    this.state.data.formulas[i][f] = e;
                    this.updateMainCount(i);
                }
                if (f === 'trashWastCount') {
                    this.state.data.formulas[i][f] = e;
                }
                if (f === 'wastCount') {
                    this.state.data.formulas[i][f] = e;
                }
            }
        }
        this.setState({ data: this.state.data });
    }
    updateModulusCount(i) {
        this.state.data.formulas[i]['modulusCount'] = (this.state.data.formulas[i]['count'] * this.state.data.formulas[i]['modulusUnitRate']);
    }
    updateMainCount(i) {
        if (this.state.data.formulas[i]['modulusUnitRate'] === 0) this.state.data.formulas[i]['count'] = 0;
        this.state.data.formulas[i]['count'] = this.FixedPointNumber((this.state.data.formulas[i]['modulusCount'] / this.state.data.formulas[i]['modulusUnitRate']), 3);
    }
    removeFormula(id) {
        var temp = [];
        for (var i = 0; i < this.state.data.formulas.length; i++) {
            if (this.state.data.formulas[i].id !== id) {
                temp.push(this.state.data.formulas[i]);
            }
        }
        this.state.data.formulas = temp;
        this.setState({ data: this.state.data });
    }
    setUserGroups(e) {
        this.state.userGroups = e;
    }
    setBranches(e) {
        this.state.branches = e;
    }
    renderForm() {
        return <div className="modal fade listModal in show" tabIndex="-1" role="dialog">
            <div className="modal-backdrop fade in" style={{ "height": "100%" }} onClick={e => this.closeMe()}></div>
            <div className="modal-dialog ui-draggable">
                <div className="modal-content">
                    <div className="modal-body" style={{ "padding": "0" }}>
                        <div className="modal-header modal-header-info">
                            <button type="button" className="close" onClick={e => this.closeMe()} aria-label="Close"><span aria-hidden="true">×</span></button>
                            <h4 className="modal-title">
                                {this.state.data.record.id !== this.defaultGuid() ? "ویرایش اطلاعات کالا/خدمت" : "افزودن کالا/خدمت جدید"}
                            </h4>
                        </div>
                        <div className="modal-body">
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-lg-4">
                                        <div className="form-group">
                                            <label className="form-label">عنوان</label>
                                            <div className="form-control-wrap">
                                                <input className="form-control" type="text" defaultValue={this.state.data.record.name} onChange={e => this.state.data.record.name = e.target.value} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-4">
                                        <div className="form-group">
                                            <label className="form-label">عنوان 2</label>
                                            <div className="form-control-wrap">
                                                <input className="form-control" type="text" defaultValue={this.state.data.record.name2} onChange={e => this.state.data.record.name2 = e.target.value} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-4">
                                        <div className="form-group">
                                            <label className="form-label">توضیحات پیش فرض</label>
                                            <div className="form-control-wrap">
                                                <input className="form-control" type="text" defaultValue={this.state.data.record.description} onChange={e => this.state.data.record.description = e.target.value} />
                                            </div>
                                        </div>
                                    </div>
                                </div>                                
                                <div className="row">
                                    <div className="col-sm-2">
                                        <div className="form-group">
                                            <label className="form-label">نوع</label>
                                            <div className="form-control-wrap">
                                                <select autocomplete="off" defaultValue={this.state.data.record.type} onChange={e => this.setType(e)} className="form-control input-sm">
                                                    <option value="1">کالا</option>
                                                    <option value="2">خدمت</option>
                                                    <option value="3">محصول</option>
                                                    <option value="4">ماده اولیه</option>
                                                    <option value="5">دارایی ثابت</option>
                                                    <option value="6">ابزار آلات مصرفی</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
									<div className="col-lg-3">
                                        <div className="form-group">
                                            <label className="form-label">انبار پیش فرض</label>
                                            <div className="form-control-wrap">
                                                <SelectAsync
                                                    value={this.state.data.record.warehouseId != this.defaultGuid() ? [{ value: this.state.data.record.warehouseId, label: this.state.data.record.warehouseName }] : null}
                                                    isMulti={false}
                                                    placeholder="انتخاب انبار"
                                                    defaultOptions
                                                    loadOptions={(inputValue, callback) => this.loadWarehousesOptions(inputValue, callback)}
                                                    onChange={e => this.setWarehouse(e)}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-3">
                                        <div className="form-group">
                                            <label className="form-label">گروه</label>
                                            <div className="form-control-wrap">
                                                <SelectAsync
                                                    value={this.state.data.record.groupId != this.defaultGuid() ? [{ value: this.state.data.record.groupId, label: this.state.data.record.groupName }] : null}
                                                    isMulti={false}
                                                    placeholder="انتخاب گروه"
                                                    defaultOptions
                                                    loadOptions={(inputValue, callback) => this.loadConstantsOptions(inputValue, callback, 2, 1)}
                                                    onChange={e => this.setGroup(e)}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                <div className="col-lg-3">
                                    <div className="form-group">
                                        <label className="form-label">واحد اصلی</label>
                                        <div className="form-control-wrap">
                                            <SelectAsync
                                                value={this.state.data.record.unitId != this.defaultGuid() ? [{ value: this.state.data.record.unitId, label: this.state.data.record.unitName }] : null}
                                                isMulti={false}
                                                placeholder="انتخاب واحد"
                                                defaultOptions
                                                loadOptions={(inputValue, callback) => this.loadUnitsOptions(inputValue, callback)}
                                                onChange={e => this.setUnit(e)}
                                            />
                                        </div>
                                    </div>
                                </div>
                                    {this.state.data.global.company.stuffSubUnitEnable === 2 &&
                                    <div className="col-lg-3">
                                        <div className="form-group">
                                            <label className="form-label">واحد فرعی</label>
                                            <div className="form-control-wrap">
                                                <SelectAsync
													isClearable={true}
                                                    value={this.state.data.record.modulusUnitId != this.defaultGuid() ? [{ value: this.state.data.record.modulusUnitId, label: this.state.data.record.modulusUnitName }] : null}
                                                    isMulti={false}
                                                    placeholder="انتخاب واحد"
                                                    defaultOptions
                                                    loadOptions={(inputValue, callback) => this.loadUnitsOptions(inputValue, callback)}
                                                    onChange={e => this.setModulusUnit(e)}
                                                />
                                            </div>
                                        </div>
                                    </div>}
                                    {this.state.data.global.company.stuffSubUnitEnable === 2 &&
                                        <div className="col-lg-3">
                                            <div className="form-group">
                                                <label className="form-label">ضریب تبدیل واحد اصلی به فرعی</label>
                                                <div className="form-control-wrap">
                                                <input className="form-control" style={{"background-color": "#f5dcdc"}} type="text" defaultValue={this.state.data.record.modulusUnitRate} onChange={e => this.state.data.record.modulusUnitRate = e.target.value} />
                                                </div>
                                            </div>
                                        </div>}
                                    {this.state.data.global.company.stuffSubUnitEnable === 2 &&
                                        <div className="col-sm-3">
                                            <div className="form-group">
                                                <label className="form-label">واحد چاپ</label>
                                                <div className="form-control-wrap">
                                                    <select autocomplete="off" defaultValue={this.state.data.record.visibleUnit} onChange={e => this.state.data.record.visibleUnit = parseInt(e.target.value)} className="form-control input-sm">
                                                        <option value="1">اصلی</option>
                                                        <option value="2">فرعی</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                    }
                                    <div className="col-sm-2">
                                        <div className="form-group">
                                            <label className="form-label">کد تفصیل</label>
                                            <div className="form-control-wrap">
                                                <input autocomplete="off" defaultValue={this.state.data.record.code} onChange={e => this.state.data.record.code = parseInt(e.target.value)} onkeypress="return isCharacterKey(event)" type="text" className="form-control input-sm ltr" maxlength="100" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-2">
                                        <div className="form-group">
                                            <label className="form-label">کد مالیاتی</label>
                                            <div className="form-control-wrap">
                                                <input maxLength="13" className="form-control ltr" type="text" defaultValue={this.state.data.record.taxNumber} onChange={e => this.state.data.record.taxNumber = e.target.value} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-2">
                                        <div className="form-group">
                                            <label className="form-label">بارکد</label>
                                            <div className="form-control-wrap">
                                                <input maxLength="150" className="form-control ltr" type="text" defaultValue={this.state.data.record.barcode} onChange={e => this.state.data.record.barcode = e.target.value} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-2">
                                        <div className="form-group">
                                            <label className="form-label">نرخ مالیات</label>
                                            <div className="form-control-wrap">
                                                <input maxLength="2" className="form-control ltr" type="text" defaultValue={this.state.data.record.taxRate} onChange={e => this.state.data.record.taxRate = e.target.value} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-2">
                                        <div className="form-group">
                                            <label className="form-label">قیمت پیش فرض</label>
                                            <div className="form-control-wrap">
                                                <input maxLength="13" className="form-control ltr" type="text" defaultValue={this.state.data.record.price} onChange={e => this.state.data.record.price = e.target.value} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-2">
                                        <div className="form-group">
                                            <label className="form-label">تعداد پیش فرض</label>
                                            <div className="form-control-wrap">
                                                <input maxLength="13" className="form-control ltr" type="text" defaultValue={this.state.data.record.defaultAmount} onChange={e => this.state.data.record.defaultAmount = e.target.value} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-2">
                                        <div className="form-group">
                                            <label className="form-label">نقطه سفارش</label>
                                            <div className="form-control-wrap">
                                                <input maxLength="13" className="form-control ltr" type="text" defaultValue={this.state.data.record.reorderPoint} onChange={e => this.state.data.record.reorderPoint = parseInt(e.target.value)} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-2">
                                        <div className="form-group">
                                            <label className="form-label">تعداد سفارش</label>
                                            <div className="form-control-wrap">
                                                <input maxLength="13" className="form-control ltr" type="text" defaultValue={this.state.data.record.reorderCount} onChange={e => this.state.data.record.reorderCount = parseInt(e.target.value)} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-sm-2">
                                        <div className="form-group">
                                            <label for="documentDate" className="title1">تاریخ تولید</label>
                                            <DatePicker
                                                inputReadOnly={false}
                                                className="form-control persian-date ltr"
                                                placeholder={"تاریخ"}
                                                isGregorian={false}
                                                showTodayButton={true}
                                                timePicker={false}
                                                onChange={(e) => { this.state.data.record.productDate = e }}
                                                value={this.getFormatedDateForDatePicker(this.state.data.record.productDate)}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-sm-2">
                                        <div className="form-group">
                                            <label for="documentDate" className="title1">تاریخ انقضا</label>
                                            <DatePicker
                                                inputReadOnly={false}
                                                className="form-control persian-date ltr"
                                                placeholder={"تاریخ"}
                                                isGregorian={false}
                                                showTodayButton={true}
                                                timePicker={false}
                                                onChange={(e) => { this.state.data.record.expireDate = e }}
                                                value={this.getFormatedDateForDatePicker(this.state.data.record.expireDate)}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-2">
                                        <div className="form-group">
                                            <label className="form-label">تصویر</label>
                                            <div className="form-control-wrap">
                                                <input type="file" onChange={(e) => { this.setProfilePic(e.target.files[0]) }} />
                                            </div>
                                        </div>
                                    </div>
                                    {!this.isBlank(this.state.data.record.image) && <div className="col-lg-2">
                                        <div className="form-group">
                                            <label className="form-label">تصویر فعلی</label>
                                            <div className="form-control-wrap">
                                                <a href={this.state.data.record.imagePath} target="_blank"><img src={this.state.data.record.imagePath} style={{ width: "100px", "height": "100px" }} /></a>
                                            </div>
                                        </div>
                                    </div>}
                                    {this.state.data.record.type === 3 && <div className="col-lg-12">
                                        <h4>فرمول ساخت</h4>
                                        <table className="table">
                                            <thead>
                                                <tr>
                                                    <th>ماده اولیه</th>
                                                    <th style={{ "width": "90px" }} className="text-center">تعداد/مقدار</th>
                                                    <th style={{ "width": "90px" }} className="text-center">واحد اصلی</th>
                                                    {this.state.data.global.company.stuffSubUnitEnable === 2 && <th style={{ "width": "80px" }}>تعداد/مقدار فرعی</th>}
                                                    {this.state.data.global.company.stuffSubUnitEnable === 2 && <th>واحد فرعی</th>}
                                                    <th className="text-center">ضایعات برگشت پذیر</th>
                                                    <th className="text-center" >آیتم تبدیل شونده</th>
                                                    <th className="text-center">ضایعات برگشت ناپذیر</th>
                                                    <th style={{ "width": "90px" }} className="text-center"></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {this.state.data.formulas.map(formula =>
                                                    <tr key={formula.id}>
                                                        <td>
                                                            <SelectAsync
                                                                defaultValue={
                                                                    formula.itemId != this.defaultGuid()
                                                                        ? [
                                                                            {
                                                                                value: formula.itemId,
                                                                                label: formula.itemName,
                                                                            },
                                                                        ]
                                                                        : null
                                                                }
                                                                components={{
                                                                    //DropdownIndicator: () => null,
                                                                    IndicatorSeparator: () => null,
                                                                }}
                                                                isMulti={false}
                                                                placeholder="انتخاب"
                                                                defaultOptions
                                                                loadOptions={(inputValue, callback) => this.loadStuffsOptions(inputValue, callback,4)}
                                                                onChange={(e) =>
                                                                    this.setFormulaValue(formula.id, 'itemId', e)
                                                                }
                                                            />
                                                        </td>
                                                        <td>
                                                            <NumberFormat
                                                                defaultValue={formula.count}
                                                                onChange={(e) =>
                                                                    this.setFormulaValue(
                                                                        formula.id,
                                                                        'count',
                                                                        parseFloat(e.target.value.replace(/,/g, ''))
                                                                    )
                                                                }
                                                                thousandSeparator={true}
                                                                prefix={''}
                                                                className="form-control text-center ltr"
                                                            />
                                                        </td>
                                                        <td>
                                                            {formula.unitName}
                                                        </td>
                                                        {this.state.data.global.company.stuffSubUnitEnable !== 2 ? null :
                                                            <td>
                                                                <NumberFormat value={formula.modulusCount} onChange={e => this.setFormulaValue(formula.id, 'modulusCount', parseFloat(e.target.value.replace(/,/g, '')))} thousandSeparator={true} prefix={''} className='form-control text-center ltr' />
                                                            </td>}
                                                        {this.state.data.global.company.stuffSubUnitEnable === 2 && <td>{formula.modulusUnitName}</td>}

                                                        <td>
                                                            <NumberFormat
                                                                defaultValue={formula.wastCount}
                                                                onChange={(e) =>this.setFormulaValue(formula.id,'wastCount',parseFloat(e.target.value.replace(/,/g, '')))}
                                                                thousandSeparator={true}
                                                                prefix={''}
                                                                className="form-control text-center ltr"
                                                            />
                                                        </td>
                                                        <td>
                                                            <SelectAsync
                                                                defaultValue={
                                                                    formula.secondaryStuffId != this.defaultGuid()
                                                                        ? [
                                                                            {
                                                                                value: formula.secondaryStuffId,
                                                                                label: formula.secondaryStuffName,
                                                                            },
                                                                        ]
                                                                        : null
                                                                }
                                                                components={{
                                                                    //DropdownIndicator: () => null,
                                                                    IndicatorSeparator: () => null,
                                                                }}
                                                                isMulti={false}
                                                                placeholder="انتخاب"
                                                                defaultOptions
                                                                loadOptions={(inputValue, callback) => this.loadStuffsOptions(inputValue, callback, 3)}
                                                                onChange={(e) =>
                                                                    this.setFormulaValue(formula.id, 'secondaryStuffId', e)
                                                                }
                                                            />
                                                        </td>
                                                        <td>
                                                            <NumberFormat
                                                                defaultValue={formula.trashWastCount}
                                                                onChange={(e) => this.setFormulaValue(formula.id, 'trashWastCount', parseFloat(e.target.value.replace(/,/g, '')))}
                                                                thousandSeparator={true}
                                                                prefix={''}
                                                                className="form-control text-center ltr"
                                                            />
                                                        </td>
                                                        <td>
                                                            <a className="hand text-danger" onClick={e => this.removeFormula(formula.id)}>حذف</a>
                                                        </td>
                                                    </tr>
                                                )}
                                                <tr>
                                                    <td colSpan={this.state.data.global.company.stuffSubUnitEnable === 2 ? "9" : "7"}>
                                                        <a className="btn btn-primary hand" onClick={e => this.addFormula()}>افزودن ماده اولیه</a>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>}
                                    <div className="col-lg-12">
                                        <div className="form-group">
                                            <label className="form-label">گروه کاربران مجاز</label>
                                            <div className="form-control-wrap">
                                                <SelectAsync
                                                    defaultValue={this.state.userGroups}
                                                    isMulti={true}
                                                    placeholder="انتخاب گروه ها"
                                                    defaultOptions
                                                    loadOptions={(inputValue, callback) => this.loadUserGroupsOptions(inputValue, callback)}
                                                    onChange={e => this.setUserGroups(e)}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-12">
                                        <div className="form-group">
                                            <label className="form-label">شعب</label>
                                            <div className="form-control-wrap">
                                                <SelectAsync
                                                    defaultValue={this.state.branches}
                                                    isMulti={true}
                                                    placeholder="انتخاب شعب"
                                                    defaultOptions
                                                    loadOptions={(inputValue, callback) => this.loadBranchesOptions(inputValue, callback)}
                                                    onChange={e => this.setBranches(e)}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-dim btn-outline-light" onClick={e => this.closeMe()}>انصراف</button>
                            <button type="submit" onClick={e => this.save(e)} className="btn btn-success">
                                ذخیره
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }

    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                this.renderForm()
            ];

        return contents;
    }
}